// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"AU5_thecomp__2s_QJ"};